import React from "react";
import {connect} from "react-redux";
import commonMethod from '../lib/commonMethod';
import cookie from 'react-cookies';
import CameraMqtt from '../components/camera/CameraMqtt'
import $ from 'jquery';
import '../assets/css/camera.scss';
import CameraMedia from '../components/camera/CameraMedia';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import EnlargeIcon from '../assets/img/dashboard/enlarge';
import TimesIcon from '../assets/img/camera/times-circle.png';
import SplitCameraIcons from '../assets/img/camera/screenSplit';
import IconOffline from '../assets/img/camera/iconOffline';
import IconInfo from '../assets/img/camera/info';
import Refresh from '../components/Refresh'
import IconStar from '../assets/img/camera/iconStar';
import Logo from '../assets/img/logo.svg';

class CameraConfig extends React.Component {
    state = {
        key: Math.random(),
        cameraConfig: null,
        slideType: 4,
        refresh: true,
        uid: this.props.userId,
        visible: false,
        isEnlarge: false,
        info: true,
        currentSlide: 0,
        screenWidth: 0
    }

    constructor(props) {
        super(props);
        this.handleSlideType = this.handleSlideType.bind(this);
        this.getUserId = this.getUserId.bind(this);
        this.disconnectedVideo = this.disconnectedVideo.bind(this);
        this.child = React.createRef();
        this.slider1 = React.createRef();
    }

    accessToken = cookie.load('accessToken');

    componentDidMount() {
        this.getUserId().then(res => {
            this.setState({uid: res})
            this.getCameraList();
        });
        document.addEventListener('fullscreenchange', (event) => {
            if (!document.fullscreenElement) {
                this.setState({isEnlarge: false})
                this.slider1.current.slickGoTo(this.state.currentSlide)
            } else {
                this.setState({isEnlarge: true})
                this.slider1.current.slickGoTo(this.state.currentSlide)
            }
        });
        $(window).scroll(function () {
            $('.enlarge-wrap').css('left', -$(window).scrollLeft());
            $('.camera-wrap').css('left', -$(window).scrollLeft());
        });
    }

    componentDidUpdate(prevProp, prevState) {
        // 새로고침 버튼 클릭시 list 호출
        if (this.props.isRefresh) {
            this.setState({refresh: true, visible: false});
            this.getCameraList();
            this.props.setIsRefresh(false);
        }
        if (this.state.slideType !== prevState.slideType) {
            this.setState({slideType: this.state.slideType})
        }
        if (this.state.cameraConfig !== prevState.cameraConfig) {
            this.setState({cameraConfig: this.state.cameraConfig})
        }
        if (this.state.isEnlarge !== prevState.isEnlarge) {
            this.setState({isEnlarge: this.state.isEnlarge})
        }
    }

    getUserId() {
        return new Promise((resolve, reject) => {
            commonMethod.requestGetWithToken('dashboard/config/user', this.accessToken, this, res => {
                resolve(res.member[0].uid);
            });
        })
    }

    getCameraList() {
        // GET Camera list
        commonMethod.requestGetWithToken('dashboard/devices/camera', this.accessToken, this, res => {
            this.getConfig(res);
            if (res.length === 0) this.setState({refresh: false})
        });
    }

    // data는 카메라 리스트들 
    getConfig(data) {
        let cameraConfigPlate = [];
        let hasBooked = JSON.parse(localStorage.getItem('booked')) || [];
        const promises = data.map(async (v, i) => {
            let result = await this.callConfig(v.id, v.uuid);
            if (result) {
                let newData = v;
                const familyName = await this.getShopList(Number(v.familyId));
                const hasBookedId = hasBooked.filter(book => book.id === v.id);
                const roomName = await this.getRoomName(Number(v.familyId), v.id);
                newData['config'] = result;
                newData['familyName'] = familyName;
                newData['roomName'] = roomName ? roomName : "ALL";
                newData['loading'] = true;
                if (hasBookedId.length > 0) {
                    newData['booked'] = true;
                }
                cameraConfigPlate.push(newData);
            } else {
                result = false;
            }
            return new Promise((res, rej) => {
                res(result)
            })
        })

        // promises는 방 번호 등이 포함된 데이터들
        Promise.all(promises).then((results) => {
            let sortCCTVwBooked = cameraConfigPlate.filter(item => item.booked && item);
            let sortCCTVwoBooked = cameraConfigPlate.filter(item => !item.hasOwnProperty('booked') && item);
            sortCCTVwoBooked.sort(function (a, b) {
                return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
            })
            this.setState({cameraConfig: sortCCTVwBooked.concat(sortCCTVwoBooked)})
            if (document.getElementById(`get-video-${0}`)) document.getElementById(`get-video-${0}`).click();
        })
    }

    callConfig(id, uuid) {
        if (id === "3e28bf2e-cc21-42ba-b94e-ca6103ac0d0b" || id === "eb453c4fc0dfc53583bc4p" || id === "eb3064bd8d2b0a2ea7a0sq") {
        } else {
            return new Promise((resolve, reject) => {
                commonMethod.requestGetWithToken(`dashboard/webrtc/configs/${id}`, this.accessToken, this, res => {
                    if (res.moto_id !== null) {
                        let ices = res.p2p_config.ices;
                        let newIces = ices.filter((item) => item.urls.indexOf('tuya') === -1);
                        res['authCode'] = res.auth;
                        res['configuration'] = {iceServers: newIces,};
                        const body = JSON.stringify({
                            uid: this.state.uid,
                            unique_id: uuid,
                            link_type: 'websocket',
                            topics: 'ipc',
                        });
                        let newData = res;
                        commonMethod.requestPostWithData(`dashboard/webrtc/access-config`, this.accessToken, body, this, async response => {
                            newData['getData'] = JSON.parse(response);
                            resolve(newData);
                        });
                    } else {
                        resolve(false);
                    }
                })
            });
        }
    }

    getShopList(familyId) {
        // 제품 리스트 API 호출
        return new Promise((resolve, reject) => {
            commonMethod.requestGetWithToken('dashboard/family', this.accessToken, this, res => {
                let shopList = res.result;
                if (familyId) {
                    var familyName = shopList.filter(family => family.familyId === familyId && family);
                    resolve(familyName[0].name)
                }
            });
        })
    }

    getRoomName(familyId, deviceId) {
        // 제품 리스트 API 호출
        return new Promise((resolve, reject) => {
            commonMethod.requestGetWithToken('dashboard/rooms/' + familyId, this.accessToken, this, res => {
                if (res.length > 0) {
                    res.result.rooms.forEach((room, i) => {
                        commonMethod.requestGetWithToken('dashboard/' + familyId + '/room/' + room.room_id + '/devices?scope=shop', this.accessToken, this, res => {
                            if (res !== undefined) {
                                var checkRoom = res.filter(camera => camera.id === deviceId);
                                if (checkRoom && checkRoom.length > 0) {
                                    resolve(room.name);
                                } else {
                                    resolve(false)
                                }
                            } else {
                                resolve(false)
                            }
                        });
                    })
                } else {
                    resolve(false);
                }
            });
        })
    }

    disconnectedVideo(i) {
        let items = this.state.cameraConfig;
        items[i].online = false;
        this.setState({cameraConfig: items});
    }

    cctvRefresh(i) {
        let items = this.state.cameraConfig;
        items[i].loading = true;
        CameraMqtt(items[i].config.getData, items[i].config, items[i].id, this.disconnectedVideo, i).then(res => {
            if (res) {
                items[i]['video'] = res;
                items[i].online = true;
                items[i].loading = false;
                this.setState({cameraConfig: items});
            } else {
                items[i].online = false;
                items[i].loading = false;
                this.setState({cameraConfig: items});
            }
        });
    }

    getVideoStreams(i) {
        let items = this.state.cameraConfig;
        CameraMqtt(items[i].config.getData, items[i].config, items[i].id, this.disconnectedVideo, i).then(res => {
            if (res) {
                items[i]['video'] = res;
                items[i].loading = false;
                items[i].online = true;
                this.setState({cameraConfig: items});
            } else {
                items[i].online = false;
                items[i].loading = false;
                this.setState({cameraConfig: items});
            }
            //if(i === items.length - 1){
            this.setState({visible: true, refresh: false});
            //}
            setTimeout(() => {
                if (document.getElementById(`get-video-${i + 1}`)) document.getElementById(`get-video-${i + 1}`).click();
            }, 500)
        })
    }


    toggleEnlarge(type) {
        let elem = document.documentElement;
        var timeout;
        if (type === 'zoomIn') {
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.mozRequestFullScreen) { /* Firefox */
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) { /* IE/Edge */
                elem.msRequestFullscreen();
            }
            // 마우스 이벤트
            document.onmousemove = function () {
                document.querySelectorAll('.cctv-info').forEach(elem => elem.style.opacity = 1);
                document.querySelector('.top-select').style.opacity = 1;
                clearTimeout(timeout);
                if (document.querySelector('.enlarge')) {
                    timeout = setTimeout(function () {
                        document.querySelectorAll('.cctv-info').forEach(elem => elem.style.opacity = 0);
                        document.querySelector('.top-select').style.opacity = 0;
                    }, 3000);
                }
            }
            this.setState({isEnlarge: true});
        } else if (type === "zoomOut") {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) { /* Firefox */
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) { /* IE/Edge */
                document.msExitFullscreen();
            }
            this.setState({isEnlarge: false});
            $('body').css('overflow-y', 'scroll')
            clearTimeout(timeout);
        }
    }

    handleInfo() {
        this.setState({info: !this.state.info})
    }

    handleSlideType(type) {
        this.setState({slideType: type, currentSlide: 0})
        this.slider1.current.slickGoTo(0)
        if (document.querySelector('.custom-dots')) document.querySelector('.custom-dots').style.transform = 'translateY(0)';
    }

    handleBook(i) {
        var updateCCTV = [...this.state.cameraConfig];
        updateCCTV[i].booked = !updateCCTV[i].booked;
        updateCCTV.sort(function (a, b) {
            return a.booked > b.booked;
        });
        this.setState({cameraConfig: updateCCTV})
        if (updateCCTV[i].booked) {
            this.SaveDataToLocalStorage({id: updateCCTV[i].id})
        } else {
            var basket = JSON.parse(localStorage.getItem('booked')) || [];
            var hasId = basket.filter(v => v.id !== updateCCTV[i].id);
            if (hasId.length === 0) {
                localStorage.removeItem('booked');
            } else {
                localStorage.setItem('booked', JSON.stringify(hasId));
            }
        }
    }


    SaveDataToLocalStorage = (data) => {
        var basket = [];
        basket = JSON.parse(localStorage.getItem('booked')) || [];
        basket.push(data);
        localStorage.setItem('booked', JSON.stringify(basket));
    }

    makeDotsClassname(dots) {
        const {currentSlide} = this.state;
        if (dots.length > 5) {
            if (currentSlide === dots.length - 1) {
                return 'end'
            } else if (currentSlide === dots.length - 2) {
                return 'beforeend'
            } else if (currentSlide < 3) {
                return 'start'
            } else if (currentSlide === 3) {
                return 'starttwo'
            } else {
                return 'middle'
            }
        } else {
            return 'normal';
        }
    }

    liClassName = (index) => {
        const {currentSlide} = this.state;
        if (currentSlide === index) {
            return 'active';
        } else if (currentSlide - 1 === index || currentSlide - 2 === index) {
            return 'size-8'
        } else if (currentSlide + 1 === index || currentSlide - 3 === index) {
            return 'size-4'
        } else if (currentSlide + 2 === index || currentSlide - 4 === index) {
            return 'size-2'
        }
    }

    render() {
        const {isEnlarge, refresh, slideType, info, key, cameraConfig, visible, currentSlide} = this.state;
        const totalSlides = cameraConfig ? Math.ceil(cameraConfig.length / slideType) : 0;
        const settings = {
            slidesToShow: 1,
            speed: 500,
            rows: slideType,
            slidesPerRow: 1,
            dots: true,
            vertical: true,
            arrows: false,
            infinite: false,
            adaptiveHeight: true,
            appendDots: dots => {
                return (
                    <>
                        <div className={`custom-dots-wrap dots-${this.makeDotsClassname(dots)}`}>
                            <ul className="custom-dots">
                                {dots.map((item, index) => {
                                    return (
                                        <li className={this.liClassName(index)} key={index}></li>
                                    );
                                })}
                            </ul>
                        </div>
                        <div className="slider-count">
                            <strong>{currentSlide + 1 < 10 ? "0" + (currentSlide + 1) : currentSlide + 1}</strong><span> / </span><span>{totalSlides < 10 ? "0" + totalSlides : totalSlides}</span>
                        </div>
                    </>
                );
            },
            onInit: () => {
                let slickListDiv = document.getElementsByClassName('slick-list')[0];
                var prevTime = new Date().getTime();
                slickListDiv.addEventListener('wheel', event => {
                    var curTime = new Date().getTime();
                    event.preventDefault()
                    if (typeof prevTime !== 'undefined') {
                        var timeDiff = curTime - prevTime;
                        if (timeDiff > 40)
                            event.deltaY > 0 ? this.slider1.current.slickNext() : this.slider1.current.slickPrev()
                    }
                    prevTime = curTime;
                });
                slickListDiv.height = 'auto';
            },
            beforeChange: (current, next) => {
                this.setState({currentSlide: next});
                if (next > 4) {
                    let translateY = next - 4;
                    document.querySelector('.custom-dots').style.transform = `translateY(-${translateY * 16}px)`;
                } else {
                    if (totalSlides > 4) document.querySelector('.custom-dots').style = "";
                }
            }
        };

        return (
            <div id="camera" className={isEnlarge ? "enlarge page" : "page"}>
                {/* 새로고침 */}
                {refresh &&
                <Refresh/>
                }
                <div className="wrap">
                    <div className="top-select">
                        {isEnlarge &&
                        <img src={TimesIcon} onClick={() => this.toggleEnlarge('zoomOut')} alt="zoomout"/>}
                    </div>
                    <div className="enlarge-wrap">
                        <section className="left-column">
                            <p>화면 설정</p>
                            <p className="camera-icon">
                                <span onClick={() => this.handleSlideType(1)}
                                      className={slideType === 1 ? "active" : ""}><SplitCameraIcons type={1}/></span>
                                <span onClick={() => this.handleSlideType(4)}
                                      className={slideType === 4 ? "active" : ""}><SplitCameraIcons type={2}/></span>
                                <span onClick={() => this.handleSlideType(9)}
                                      className={slideType === 9 ? "active" : ""}><SplitCameraIcons type={3}/></span>
                            </p>
                            <p onClick={() => this.handleInfo()}
                               className={info ? "camera-info active" : "camera-info"}><span><IconInfo/></span></p>
                        </section>
                        <section className="right-column">
                            <p>카메라 : {cameraConfig ? cameraConfig.length : 0}</p>
                            <span className="enlarge-icon"
                                  onClick={() => this.toggleEnlarge('zoomIn')}><EnlargeIcon/></span>
                        </section>
                    </div>
                    {visible && <div className="camera-wrap">
                        <section id="slider-wrap" className={`slider-container-wrap grid-${slideType}`}>
                            {/** 전체화면인 경우 X 만 보이게 */}
                            {isEnlarge &&
                            <button onClick={(e) => this.toggleEnlarge('zoomOut')} className="close-fullscreen"><img
                                src={TimesIcon} alt="close"/></button>}

                            <Slider key={isEnlarge ? "slider-2" : key}  {...settings}
                                    ref={slider => this.slider1.current = slider && slider['innerSlider']}>
                                {cameraConfig && cameraConfig.map((v, i) => (
                                    <section key={i}
                                             className={v.online ? `slide-${slideType} online` : `slide-${slideType} offline`}>
                                        {v.loading &&
                                        <div className="slide-refresh-wrap"><img src={Logo} alt="logo"/></div>}
                                        {!v.loading && v.online &&
                                        <CameraMedia slideType={slideType} noVideo={this.disconnectedVideo} index={i}
                                                     video={v.video}/>}
                                        {info && <p className={v.online ? "cctv-setting" : "cctv-setting off"}><span
                                            onClick={() => this.handleBook(i)}
                                            className={v.booked ? "booked" : ""}><IconStar/></span></p>}
                                        <div className={v.online ? "offline-overlay" : "active offline-overlay"}>
                                            <div>
                                                <p><span><IconOffline/></span><span>오프라인</span></p>
                                                <p>네트워크 연결 상태를 확인하여주시거나 제품 연결 상태를 확인하신 후
                                                    <a id={`cctv-reset-${i}`} href={()=>false} onClick={() => this.cctvRefresh(i)} >새로고침</a>을 눌러주세요.</p>
                                            </div>
                                        </div>
                                        {info && <p className={v.online ? "cctv-info" : "cctv-info off"}>
                                            <strong>{v.name}</strong>
                                            <span><i>{v.familyName}</i> / <i>{v.roomName}</i></span>
                                        </p>}
                                    </section>
                                ))}
                            </Slider>
                            {cameraConfig && totalSlides <= 1 &&
                            <div className="slider-count"><strong>01</strong><span> / </span><span>01</span></div>}
                        </section>
                    </div>}
                    {cameraConfig && cameraConfig.map((v, i) => <button id={`get-video-${i}`} key={i}
                                                                        onClick={() => this.getVideoStreams(i)}></button>)}
                </div>
            </div>)
    }
}



function mapStateToProps(state) {
    return {
        accessToken: state.hejhome.accessToken, 
        isRefresh: state.hejhome.isRefresh, 
        userId: state.hejhome.userId,
        navigationWidth: state.hejhome.navigationWidth, 
    }
}

// dispatch - set
const mapDispatchToProps = dispatch => ({
    setAccessToken: (token) => dispatch({
        type: 'setAccessToken',
        accessToken: token,
    }),
    setUserId: (id) => dispatch({
        type: 'setUserId',
        userId: id,
    }),
    setIsRefresh: (bool) => dispatch({
        type: 'setIsRefresh',
        isRefresh: bool,
    }),
});

CameraConfig = connect(mapStateToProps, mapDispatchToProps)(CameraConfig);

export default CameraConfig;
